module.exports = __webpack_public_path__ + "static/img/company_history_renwu1979.5d23a653.jpg";